// jshint esversion: 6
// Append Expand to Parents

const jsMenuSlider = `<button aria-label="Expand menu" class="slider js-submenu-slider">
                        <i class="fal fa-chevron-down" aria-hidden="true"></i>
                      </button>`;

$('.off-canvas__menu .menu-item-has-children > a').after(jsMenuSlider);

// Expand/collapse on-click
$('.js-submenu-slider').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active').siblings('.sub-menu').finish().slideToggle();
})
